<template>
  <div style="display:inline-block">
    <el-select
      v-if="status==='select'"
      v-model="tagType"
      style="width:100%"
      placeholder="请选择商品分类"
      @change="handleChange">
      <el-option
        v-if="showAll"
        label="全部"
        :value="''"></el-option>
      <el-option
        v-for="item in categorys"
        :key="item.classId"
        :label="item.className"
        :value="item.classId">
      </el-option>
    </el-select>
    <span v-else>{{ categoryName }}</span>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'VendorCategorySelect',
  components: {},
  props: {
    status: {
      type: String,
      default: 'select'
    },
    showAll: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object
    },
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categorys: [],
      categoryName: ''
    }
  },
  computed: {
    tagType: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.categoryName = (_.find(this.categorys, o => o.classId === val) || {}).classFullName
      }
    }
  },
  watch: {
    'option.vendorId': {
      handler(val, oldVal) {
        if (!this.immediate) {
          if (val && val !== oldVal) {
            this.fetchList()
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.immediate) {
      this.fetchList()
    }
  },
  methods: {
    handleChange() {
      this.callback && this.callback()
    },
    fetchList() {
      this.$store.dispatch('vendor/getvendorcategorys', {
        payload: this.option,
        success: (res) => {
          this.categorys = res.data.categorys
          this.categoryName = (_.find(res.data.categorys, o => o.classId === this.tagType) || {}).classFullName
        },
        fail: () => {
          this.categorys = []
          this.categoryName = ''
        }
      })
    }
  }
}
</script>
